module.exports = __webpack_public_path__ + "011075ab46c39d4273e6b480d06b72e4.png";